import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  supportButton: {
    color: theme.palette.text.primary,
    width: theme.spacing(5.5),
    height: theme.spacing(5.5),
    marginRight: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      width: theme.spacing(3),
      height: theme.spacing(3),
      marginRight: theme.spacing(0.5),
    },
  },
}));
